import { Fn }			from "ts-base/fn";
import { Nullable }		from "ts-base/nullable";

import * as upModel		from "@geotoura/shared/upModel";

export const sumBy	= <T>(items:ReadonlyArray<T>, extract:Fn<T, number>):number => sum(items.map(extract));

export const sum	= (items:ReadonlyArray<number>):number => items.reduce((a, b) => a+b, 0);

export const stepOrKeep	= (current:number, size:number, direction:"previous"|"next"):number =>
	step(current, size, direction) ?? current;

export const step	= (current:number, size:number, direction:"previous"|"next"):number|null =>
	direction === "previous"
	?	(current > 0		? current - 1 : null)
	:	(current < size-1	? current + 1 : null);

export const upDown	= (dir:"up"|"down")	=> (value:number):number =>
	dir === "up"	? (value + 1)						:
	dir === "down"	? Math.max(value - 1, 0)	:
	Fn.impossible(dir);

export const labelEntryPoint = (entryPoint:upModel.EntryPoint):string =>
	[
		Nullable.then(entryPoint.route)(it => `route: ${it}`),
		Nullable.then(entryPoint.region)(it => `region: ${it}`),
		Nullable.then(entryPoint.territory)(it => `territory: ${it}`),
	]
	.filter(it => it !== null)
	.join(",");
